'use client';

import { useEffect } from 'react';
import { Button } from '@/components/ui/Button';

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    // Log the error to an error reporting service
    console.error(error);
  }, [error]);

  return (
    <div className="flex flex-col items-center justify-center min-h-[70vh] px-4 py-16 text-center">
      <div className="relative mb-8">
        <div className="absolute inset-0 bg-gradient-to-r from-futuristic-blue to-futuristic-purple opacity-20 blur-xl rounded-full"></div>
        <svg
          className="relative z-10 w-24 h-24 text-futuristic-red"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
          />
        </svg>
      </div>
      <h1 className="mb-4 text-4xl font-bold text-white">Something went wrong</h1>
      <p className="mb-8 text-lg text-gray-300 max-w-md">
        We apologize for the inconvenience. Our team has been notified and is working to fix the issue.
      </p>
      <Button 
        onClick={reset}
        variant="neon"
        size="lg"
        className="px-8 py-3"
      >
        Try again
      </Button>
    </div>
  );
} 